module.exports = __webpack_public_path__ + "img/default-img.2f45a7de.jpg";